/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

/* Filters */

angular.module('access.Utils')
    .filter('markup', ['$sce', function($sce) {
        var map = {
            '*': 'b',
            '~': 'i'
            },
            regexArray = [],
            regexPath = '';

        for (var symbol in map) {
            regexArray.push( '\\' + symbol + '[^\\' + symbol + ']+\\' + symbol );
        }

        regexPath = regexArray.join('|');

        function addHtmlTag(match) {
            var symbol = match[0],
                markup;

            if (!(symbol in map)) {
                return match;
            }

            markup = match.replace(new RegExp('\\' + symbol, 'g'), '');

            markup = markup.replace(new RegExp(regexPath, 'g'), addHtmlTag);

            return '<' + map[symbol] + '>' + markup + '</' + map[symbol] + '>';
        }

        return function(text){
            return text.replace(new RegExp(regexPath, 'g'), addHtmlTag);
        }
    }]);